import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  info = null;
  public waslogged: boolean = true
  constructor(private http: HttpClient, private router: Router) { }

  login(data) {
    data['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http.post<any>(environment.api + '-user', data).toPromise().then(res => {
      localStorage.setItem('_token', res.UserId);
      localStorage.setItem('access_token', res?.access_token || '');
      localStorage.setItem('user', JSON.stringify(res.User));
      this.waslogged = res.waslogged;

      // this.user = JSON.parse(localStorage.getItem('user'));

      if (res.User.customertypecode_formatted === 'Developer') {
        this.router.navigate(['/admin/my-projects']);
      } else {
        if (!this.waslogged) {
          this.router.navigate(['/admin/settings']);
        } else {
          this.router.navigate(['/admin']);
        }
      }
    }, error => {
      error.error.error;
    })
  }

  reset(data) {
    data['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http.post<any>(environment.api + '-user/forgotpass', data).toPromise().then(res => {
      if (res.UserId) {
        localStorage.setItem('_token', res.UserId);
        localStorage.setItem('access_token', res.access_token || '');
        localStorage.setItem('user', JSON.stringify(res.User));
        this.router.navigate(['/admin']);
      }
      return res;
    });
  }
}
